/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const tropicalCycloneAnnotationPointsTemplate: any = {
  x: null,
  y: null,
  marker: {
    size: 6,
    fillColor: '#fff',
    strokeColor: '#068A55',
    radius: 2,
  },
  label: {
    borderColor: '#FF4560',
    offsetY: 0,
    style: {
      color: '#fff',
      background: '#FF4560',
    },
    text: '',
  },
};

export const payoutElibileAnnotationsTemplate: any = {
  x: null,
  borderColor: '#068A55',
  label: {
    borderColor: '#068A55',
    style: {
      color: '#fff',
      background: '#068A55',
    },
    orientation: 'horizontal',
    text: '',
  },
};
export const chartOptions: any = {
  chart: {
    fontFamily: 'Inter',
    foreColor: '#068A55',
    toolbar: {
      show: true,
      offsetX: 0,
      offsetY: 0,
      tools: {
        download: true,
        selection: false,
        zoom: true,
        zoomin: true,
        zoomout: true,
        pan: false,
        reset: true,
        customIcons: [],
      },
      export: true,
      autoSelected: 'zoom',
    },
  },
  annotations: {
    points: [],
    xaxis: [],
  },
  dataLabels: {
    enabled: false,
  },
  tooltip: {
    style: {
      fontSize: '14px',
      fontFamily: 'Inter',
    },
  },

  fill: {
    gradient: {
      enabled: true,
      color: '#068A55',
    },
  },
  theme: {
    monochrome: {
      enabled: true,
      color: '#068A55',
    },
  },
  grid: {
    show: true,
    borderColor: '#068A55',
    strokeDashArray: 1,
  },
  markers: {
    size: 5,
    colors: ['#fff'],
    strokeColor: '#068A55',
    strokeWidth: 3,
  },
  xaxis: {
    categories: null,
    labels: {
      style: {
        fontSize: '12px',
        fontWeight: 500,
      },
    },
    axisBorder: {
      color: '#000000',
    },
    axisTicks: {
      color: '#000000',
    },
  },
  yaxis: {
    labels: {
      style: {
        colors: ['#000000'],
        fontSize: '12px',
        fontWeight: 500,
      },
    },
  },

  responsive: [
    {
      breakpoint: 768,
      options: {
        yaxis: {
          show: false,
        },
      },
    },
  ],
};
